import React from 'react';
import {Card, CardActions, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import { translate } from 'react-i18next';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import Snackbar from 'material-ui/Snackbar';
import createHistory from 'history/createBrowserHistory';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import OfferDelete from './OfferDelete';
import NameAndSelectVariety from './NameAndSelectVariety';
import DateRange from './DateRange';
import Discount from './Discount';
import UsableTimes from './UsableTimes';
import CouponCode from './CouponCode';
import OfferStandsList from './OfferStandsList';
import CouponCodeRemoveDialog from './CouponCodeRemoveDialog';
import generateRandomCoupon from './RandomCoupon';
import './Offer.css';

class Offer extends React.Component {
  constructor(props) {
    super(props);

    const {offerKey} = this.props.match.params;

    this.state = {
      offerKey,
      name: '',
      openDeleteDialog: false,
      openCouponRemoveDialog: false,
      stands: [],
      offerStands: [],
      products: [],
      offerProducts: [],
      currentStands: [],
      loadingIndicator: 'flex',
      isActive: true,
      disableDates: true,
      today: Date.now(),
      startDate: null,
      endDate: null,
      discount: '',
      discountError: '',
      discountType: '',
      savedSnackbar: false,
      usableInfinitely: true,
      usableTimes: '',
      couponCode: '',
      couponCodeUse: false,
      unsavedCouponCode: false
    };
  }

  componentDidMount = () => {
    const {offerKey} = this.state;
    const {firebase} = this.props;
    const {shopkeeperId} = this.props.user;
    if (!offerKey) return;
    if(!shopkeeperId) return;

    firebase
      .database()
      .ref(`shopkeepers/${shopkeeperId}/offers/${offerKey}`)
      .once('value', (data) => {
        let offer = data.val();
        this.setState({...offer});
        if (offer.couponCode) {
          this.setState({couponCodeUse: true});
        }
      })
      .then(() => firebase.database().ref(`shopkeepers/${shopkeeperId}/stands/`)
        .orderByChild('name')
        .once('value', (queryStands) => {
          const stands = [];
          queryStands.forEach((data) => {
            const stand = {
              key: data.key,
              ...data.val()
            };
            stands.push(stand);
          });
          this.setState({stands});
        }).then(() => {
          this.productsRef = firebase.database().ref(`shopkeepers/${shopkeeperId}/products`).orderByChild('name');
          this.productsRef.once('value', (products) => {
            products.forEach((data) => {
              let product = {
                key: data.key,
                ...data.val()
              };
              const offerStands = this.state.stands.slice();
              let productInSomeStand = false;
              offerStands.forEach((stand) => {
                if (typeof stand.products[product.key] !== 'undefined') {
                  if (!productInSomeStand) {
                    productInSomeStand = true;
                  }
                }
              });
              if (productInSomeStand) {
                const offerProducts = this.state.products.slice();
                offerProducts.push(product);
                this.setState({products: offerProducts});
              }
            });
          });
        }).then(() => {
          this.retrieveOfferProducts(this.state.offerStands, this.state.offerProducts);
          this.setState({loadingIndicator: 'none'});
        }));
  }

  retrieveOfferProducts = (offerStands, offerProducts) => {
    const currentStands = [];
    this.state.stands
      .filter((stand) => {
        if (offerStands.length === 0) return stand;
        return offerStands.indexOf(stand.key) > -1;
      })
      .forEach((stand) => {
        const currentProducts = [];
        if(stand.products) {
          Object.keys(stand.products)
            .filter((productKey) => {
              if (offerProducts.length === 0) return productKey;
              return offerProducts.indexOf(productKey) > -1;
            })
            .forEach((productKey) => {
              let offerProduct = {
                key: productKey,
                name: stand.products[productKey].name,
                price: stand.products[productKey].price
              };
              offerProduct = this.applyDiscount(offerProduct);
              currentProducts.push(offerProduct);
            });
          if (currentProducts.length > 0) {
            stand.currentProducts = currentProducts;
            currentStands.push(stand);
          }
        }
      });
    this.setState({currentStands});
  }

  handleSave = () => {
    const valid = [this.validateName, this.validateDiscount].map((fn) => fn()).every(x => (x));
    if (!valid) return;

    const {firebase, user} = this.props;

    const offer = {
      name: this.state.name,
      offerStands: this.state.offerStands,
      offerProducts: this.state.offerProducts,
      discount: this.state.discount,
      discountType: this.state.discountType,
      isActive: this.state.isActive,
      disableDates: this.state.disableDates,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      usableInfinitely: this.state.usableInfinitely,
      usableTimes: this.state.usableTimes,
      couponCode: this.state.couponCode
    };

    firebase.database()
      .ref(`shopkeepers/${user.shopkeeperId}/offers/${this.state.offerKey}`)
      .update(offer);

    if (this.state.couponCode) {
      firebase.database()
        .ref(`couponCodes/${this.state.couponCode}`)
        .update({
          offerId: this.state.offerKey,
          shopkeeperId: user.shopkeeperId,
          info: {
            offerName: this.state.name,
            shopkeeperName: user.shopName
          }
        });
    }

    this.setState({savedSnackbar: true, unsavedCouponCode: false});
  }

  handleNameChange = (event, name) => this.setState({name, nameError: ''})

  validateName = () => {
    const {t} = this.props;
    if (!this.state.name) {
      this.setState({nameError: t('offer.nameRequired')});
      return false;
    }
    return true;
  }

  handleStandChange = (event, index, offerStands) => {
    this.setState({offerStands});
    this.retrieveOfferProducts(offerStands, this.state.offerProducts);
  }

  handleProductChange = (event, index, offerProducts) => {
    this.setState({offerProducts});
    this.retrieveOfferProducts(this.state.offerStands, offerProducts);
  }

  handleStartDateChange = (event, date) => {
    if (date <= this.state.today) {
      this.setState({isActive: true});
    } else {
      this.setState({isActive: false});
    }
    this.setState({
      startDate: date.getTime()
    });
  };

  handleEndDateChange = (event, date) => {
    if (!this.state.isActive) {
      if (this.state.startDate < this.state.today) {
        this.setState({isActive: true});
      }
    }
    this.setState({
      endDate: date.getTime() + 86399999
    });
  };

  setDisableDates = (event, disableDates) => {
    if (disableDates) {
      this.setState({startDate: null, endDate: null, isActive: true});
    } else {
      this.setState({startDate: this.state.today});
    }
    this.setState({disableDates});
  }

  handleDiscountTypeChange = (event, discountType) => {
    this.setState({discountType, discount: ''});
  }

  handleDiscountChange = (event, discount) => {
    this.setState({discount: discount.trim().replace(',','.'), discountError: ''});
  }

  validateDiscount = () => {
    const discount = this.state.discount;
    const {t} = this.props;

    if (!discount) {
      this.setState({discountError: t('offer.discountRequired')});
      return false;
    } else if (isNaN(discount)) {
      this.setState({discountError: t('offer.discountNotNumber')});
      return false;
    } else if (parseFloat(discount) < 0)  {
      this.setState({discountError: t('offer.discountLessThanZero')});
      return false;
    } else if (parseFloat(parseFloat(discount).toFixed(2)) !== parseFloat(discount)) {
      this.setState({discountError: t('offer.tooManyDecimals')});
      return false;
    }

    return true;
  }

  applyDiscountChange = () => {
    if (!this.validateDiscount()) return;

    const currentStands = [];
    this.state.currentStands.forEach((stand) => {
      const currentProducts = [];
      stand.currentProducts.forEach((offerProduct) => {
        offerProduct = this.applyDiscount(offerProduct);
        currentProducts.push(offerProduct);
      });
      stand.currentProducts = currentProducts;
      currentStands.push(stand);
    });
    this.setState({currentStands, flash: true});
    setTimeout(() => {
      this.setState({flash: false});
    }, 100);

    return true;
  }

  applyDiscount = (offerProduct) => {
    if(!this.state.discount) {
      offerProduct.discountPrice = offerProduct.price;
      return offerProduct;
    }

    if (this.state.discountType === 'percent') {
      offerProduct.discountPrice = Number(offerProduct.price * (100-this.state.discount) / 100).toFixed(2);
    } else if (this.state.discountType === 'euro') {
      offerProduct.discountPrice = offerProduct.price - this.state.discount;
    } else if (this.state.discountType === 'certain') {
      if (this.state.discount < offerProduct.price) {
        offerProduct.discountPrice = this.state.discount;
      } else {
        offerProduct.discountPrice = offerProduct.price;
      }
    }

    if (offerProduct.discountPrice < 0 ) {
      offerProduct.discountPrice = 0;
    }
    return offerProduct;
  }

  handleDiscountUseChange = (event, usableInfinitely) => {
    if (usableInfinitely) {
      this.setState({usableTimes: ''});
    } else {
      this.setState({usableTimes: 1});
    }
    this.setState({usableInfinitely});
  }

  handleDiscountUseAmountChange = (event) => {
    const isInteger = event.target.value >>> 0 === parseFloat(event.target.value);
    const isEmpty = event.target.value === '';
    if (isInteger || isEmpty) {
      this.setState({usableTimes: parseInt(event.target.value, 10)});
    }
  }

  handleCouponCodeUseChange = (event, couponCodeUse) => {
    if (!couponCodeUse) {
      if (this.state.unsavedCouponCode) {
        this.setState({couponCode: '', couponCodeUse: false});
      } else {
        this.setState({openCouponRemoveDialog: true});
      }
    } else {
      this.generateUniqueCouponCode();
      this.setState({couponCodeUse});
    }
  }

  generateUniqueCouponCode = () => {
    const {firebase} = this.props;

    let couponCode = generateRandomCoupon();
    firebase.database()
      .ref(`couponCodes/${couponCode}`)
      .once('value', (snapshot) => {
        if (snapshot.exists()) {
          this.generateUniqueCouponCode();
        } else {
          this.setState({couponCode, unsavedCouponCode: true});
        }
      });
  }

  closeSnackbar = () => {this.setState({savedSnackbar: false});}

  handleOpenDeleteDialog = () => {
    this.setState({openDeleteDialog: true});
  }
  handleCloseDeleteDialog = () => {
    this.setState({openDeleteDialog: false});
  }
  handleCloseCouponRemoveDialog = (isCouponRemoved) => {

    this.setState({openCouponRemoveDialog: false});

    if(!isCouponRemoved) return;

    this.setState({couponCode: '', couponCodeUse: false, savedSnackbar: true});
  }

  render()  {
    const {t} = this.props;

    return (
      <div>
        <Card className='cardStyle' >
          <Toolbar>
            <ToolbarGroup firstChild={true}>
              <IconButton
                onTouchTap={createHistory().goBack}
              >
                <ArrowBack color="rgba(0,0,0,0.4)" />
              </IconButton>
              <ToolbarTitle text={t('offer.edit')} />
            </ToolbarGroup>
            <ToolbarGroup lastChild={true}>
              <IconMenu
                iconButtonElement={<IconButton touch={true}><MoreVertIcon /></IconButton>}
                useLayerForClickAway={true}
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                targetOrigin={{horizontal: 'right', vertical: 'top'}}>
                <MenuItem
                  primaryText={t('offer.delete')}
                  onTouchTap={this.handleOpenDeleteDialog}/>
              </IconMenu>
              <OfferDelete
                handleClose={this.handleCloseDeleteDialog}
                open={this.state.openDeleteDialog}
                offerName={this.state.name}
                offerKey={this.state.offerKey}
                couponCode={this.state.couponCode}/>
            </ToolbarGroup>
          </Toolbar>
          <CardText>
            <div className='row' >
              <NameAndSelectVariety
                name={this.state.name}
                handleNameChange={this.handleNameChange}
                nameError={this.state.nameError}
                validateName={this.validateName}
                offerStands={this.state.offerStands}
                offerProducts={this.state.offerProducts}
                stands={this.state.stands}
                products={this.state.products}
                handleStandChange={this.handleStandChange}
                handleProductChange={this.handleProductChange}
              />
              <DateRange
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                disableDates={this.state.disableDates}
                setDisableDates={this.setDisableDates}
                isActive={this.state.isActive}
                handleStartDateChange={this.handleStartDateChange}
                handleEndDateChange={this.handleEndDateChange}/>
            </div>
            <div className='row' >
              <Discount
                discountType={this.state.discountType}
                discount={this.state.discount}
                discountError={this.state.discountError}
                handleDiscountTypeChange={this.handleDiscountTypeChange}
                handleDiscountChange={this.handleDiscountChange}
                applyDiscountChange={this.applyDiscountChange}/>
              <UsableTimes
                usableTimes={this.state.usableTimes}
                usableInfinitely={this.state.usableInfinitely}
                handleDiscountUseAmountChange={this.handleDiscountUseAmountChange}
                handleDiscountUseChange={this.handleDiscountUseChange}/>
            </div>
            <div className='row' >
              <CouponCode
                couponCodeUse={this.state.couponCodeUse}
                couponCode={this.state.couponCode}
                handleCouponCodeUseChange={this.handleCouponCodeUseChange}/>
              <CouponCodeRemoveDialog
                handleClose={this.handleCloseCouponRemoveDialog}
                open={this.state.openCouponRemoveDialog}
                offerKey={this.state.offerKey}
                couponCode={this.state.couponCode}/>
            </div>
          </CardText>

          <CardActions>
            <RaisedButton label={t('save')} primary  onTouchTap={this.handleSave} />
          </CardActions>

          <Snackbar
            open={this.state.savedSnackbar}
            message={t('offer.saved')}
            autoHideDuration={4000}
            onRequestClose={this.closeSnackbar}
          />

        </Card>

        <OfferStandsList
          stands={this.state.stands}
          products={this.state.products}
          currentStands={this.state.currentStands}
          loadingIndicator={this.state.loadingIndicator}
          flash={this.state.flash}/>
      </div>
    );
  }

}

const enhance = compose(translate(), firebase, user);

export default enhance(Offer);



// WEBPACK FOOTER //
// ./src/Offer/Offer.js